import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthNavigationService } from '../services/auth-navigation/auth-navigation.service';

export const registerRedirectGuard: CanActivateFn = (route) => {
  const authNavigation = inject(AuthNavigationService);
  return authNavigation.createRegisterRedirectUrlTree(route);
};
